import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = (props) => {
	const {labels, values, title} = props;

	const colors = ["#FF9416", "#40A0C1", "#126480", "#FF9E67", "#FFC267", "#BF533B", "#237389", "#FF9090", "#E2E7ED"];

	const data = {
		labels,
		datasets: [
			{
				data: values,
				backgroundColor: colors
			},
		],
	};

	const options = {
		cutout: '80%',
		maintainAspectRatio: false,
		aspectRatio: 1, // default value is 2
		plugins: {
			datalabels: {
				formatter: (value) => {
					return value + '%';
				}
			},
			legend: {
				display: true, // This will show the legend
				position: 'bottom' // This will move it to the bottom
			},
			title: {
				display: true,
				text: title
			}
		}
	};

	return (
		<div style={{width: '70%', height: '90%', display: 'flex', paddingTop: '0px', margin: '0 auto'}}>
			<Doughnut data={data} options={options} />
		</div>
	);
};

export default DoughnutChart;
